import { render, staticRenderFns } from "./reg_bhumie.vue?vue&type=template&id=3182b3e6&"
import script from "./reg_bhumie.vue?vue&type=script&lang=js&"
export * from "./reg_bhumie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports